import React from "react";

class Page7 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 4) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0 d-md-block">Learning Points</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
            </nav>

            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <p>
                          <ol>
                            <li>
                              Keep reflecting and learning. As you think about
                              the skills, knowledge and experiences you gain,
                              consider what you need and proactively bridge
                              those gaps.
                            </li>
                            <br />
                            <li>
                              Seek out a mentor who you can talk to in
                              confidence. They could be someone you know
                              professionally or outside of your immediate work.
                              Before seeking a mentor's assistance, make a plan.
                              What do you expect from your mentor? What do you
                              want to focus on?
                            </li>
                            <br />
                            <li>
                              Working on your emotional intelligence is one of
                              the most important aspects of your personal
                              development.
                            </li>
                          </ol>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page7;
